import {Col, message, Row} from "antd";
import CustomerVerificationForm from "../../../components/admin/customerVerification/customerVerificationForm";
import {UserOutlined} from "@ant-design/icons";
import {CustomerDto} from "../../../dto/CustomerDto";
import adminService from "../../../service/adminService";
import {MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {useEffect, useState} from "react";
import {WorkbasketTableDto} from "../../../dto/admin/WorkbasketTableDto";


const CustomerVerificationFormDetails = (props: any) => {
    const [customerDto, setCustomerDto] = useState<CustomerDto>();
    const [workBasketDto, setWorkBasketDto] = useState<WorkbasketTableDto>();
    const [rmCode, setRmCode] = useState<number | null>();
    const getCustomerDetails = (workbasketDto: any) => {
        adminService.getCustomerDetailsForVerification(workbasketDto.workId).then(res => {
            if (res.data !== null) {
                let results = res.data.results;
                setCustomerDto(results.customerMstDto)
                setWorkBasketDto(workbasketDto)
                setRmCode(results.rmCode)
            } else {
                message.error(MSG_FAILED_TO_FETCH_PENDING_DETAIL_VERIFICATION_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    useEffect(() => {
        const workBasketDataStr = localStorage.getItem("workBasketData");
        const workbasketDto = workBasketDataStr !== null ? JSON.parse(workBasketDataStr) : null;

        getCustomerDetails(workbasketDto)
    }, [])
    return (
        <>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'>
                        <div className='header_icon header-icon-center'>
                            <UserOutlined/>
                        </div>
                        Customer Verification
                    </h2>
                </Col>
            </Row>
            <Row gutter={[16, 16]} className='margin_top_20'>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    {workBasketDto ? <CustomerVerificationForm customerDto={customerDto} workBasketDto={workBasketDto}
                                                               rmCode={rmCode}/> : <div className="loader-container">
                        {/*<Spin size="large" tip="Loading"></Spin>*/}
                    </div>}

                </Col>
            </Row>
        </>
    )
}
export default CustomerVerificationFormDetails;

